<div
  class="custom-formly-field-collapsible row col pb-2 mb-3 shadow-sm rounded">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="d-flex align-items-center">
            <div *ngIf="to['iconName']" class="icon-wrapper me-2">
              <i class="fas fa-{{ to['iconName'] }}"></i>
            </div>
            <span>{{ to.label }}</span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container #fieldComponent></ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</div>
